import React from 'react';
import { Box, Paper, Typography, Button, Stack, alpha, useTheme } from '@mui/material';
import { Block } from '@mui/icons-material';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { SoftChip } from '../components/SoftChip';

export const AccessDeniedPage: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, sm: 4 },
          maxWidth: 480,
          width: '100%',
          textAlign: 'center',
          borderRadius: 3,
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            bgcolor: alpha(theme.palette.error.main, 0.12),
            color: theme.palette.error.main,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Block sx={{ fontSize: 40 }} />
        </Box>
        <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
          Accesso negato
        </Typography>
        <Stack direction="row" spacing={0.75} justifyContent="center" sx={{ mb: 2 }}>
          <SoftChip label="PLATFORM" tone="warning" />
          <SoftChip label="solo operatori" tone="default" />
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Questa superficie è riservata agli operatori della piattaforma. Se sei
          un cliente di un tenant, accedi dalla tua app gestionale.
        </Typography>
        <Button
          variant="outlined"
          onClick={async () => { await signOut(auth); navigate('/login'); }}
        >
          Esci e cambia account
        </Button>
      </Paper>
    </Box>
  );
};
